import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchServiceAndTaxSettings } from "../services/Settings/ServicesandTaxSettingsAndSessios/ServicesAndTaxApi";
// TODO: استيراد دالة جلب إعدادات الطباعة من API المناسب
// import { fetchPrintingSettings } from "../services/Settings/PrintingApi";

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const s = await fetchServiceAndTaxSettings();

        // ✅ جلب إعدادات الطباعة
        // const printingSettings = await fetchPrintingSettings();

        // ✅ دمج الإعدادات
        const combinedSettings = {
          ...s,
          printing_method: s.printing_method || "automatic", // استخدام القيمة من API أو القيمة الافتراضية
          // printing_method: printingSettings?.printing_method || "automatic"
        };

        setSettings(combinedSettings);
        localStorage.setItem("settings", JSON.stringify(combinedSettings));
      } catch (err) {
        const cached = localStorage.getItem("settings");
        if (cached) {
          const parsedSettings = JSON.parse(cached);
          // ✅ التأكد من وجود printing_method في الإعدادات المخزنة
          if (!parsedSettings.printing_method) {
            parsedSettings.printing_method = "automatic";
          }
          setSettings(parsedSettings);
        }
        setError("❌ فشل في تحميل الإعدادات");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading, error }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
